import { ImageListType, ImageType } from 'react-images-uploading';
import {
  AddressType,
  OptionsListType,
  TelephoneType,
} from '../../utils/@globalTypes';
import { PayloadWithCallback, ResponseData } from './@types';

// STATE TYPES

export type MainObject = {
  id: string;
  owner: {
    id: number;
    first_name: string;
    last_name: string;
    phone: TelephoneType | null;
    website: string;
    image: string | null;
  };
  object_type: ObjectTypeData;
  name: string;
  photo: string | null;
  booking_photo: string | null;
  country: string;
  full_address: AddressType | null;
  created_at: string;
  rules: File | null;
  text_rules: string | null
};

export type MainObjectList = MainObject[];

export type CountryType = {
  countryCode: string;
  countryLabel: string;
};

export type CountryList = CountryType[];

// export type MainObjectContact = { -CONTACTS
//   email: string;
//   first_name: string;
//   id: number;
//   last_name: string;
//   main_object: MainObjectShort;
//   middle_name: string;
//   mobile_phone: string;
//   position: { id: number; name: string };
//   work_phone: string;
// };

// export type MainObjectContactsList = MainObjectContact[]; -CONTACTS

export type ObjectTypeData = {
  id: number;
  title: string;
  example: string;
};

export type ObjectTypesList = ObjectTypeData[];

export type ObjectTypesData = {
  fullData: ObjectTypesList;
  optionsList: OptionsListType;
};

// PAYLOAD TYPES

export type CreateObjectPayload = {
  name: string;
  country: string;
  object_type: number;
};

export type CreateObjectPayloadData = PayloadWithCallback<CreateObjectPayload>;

// export type CreateObjectPayloadData = {
//   data: ObjectPayload;
//   callback?: (value?: any) => void;
//   token?: string;
// };

export type ObjectTypesPayload = {
  title?: string;
  limit?: number;
  offset?: number;
};

export type GetMainObjectsPayload = {
  name?: string;
  object_type?: number;
  country?: string;
  address?: string;
  limit?: number;
  offset?: number;
};

// export type GetMainObjectsPayloadData = PayloadWithCallback<GetMainObjectsPayload>;

export type UpdateObjectPayload = {
  data: FormData;
  id: string;
};

export type UpdateObjectPayloadData = {
  name?: string;
  country?: string;
  address?: string;
  object_type?: number;
  photo?: Blob;
};

// export type ContactPersonPayload = {  -CONTACTS
//   last_name: string;
//   first_name: string;
//   middle_name: string;
//   work_phone: string;
//   mobile_phone: string;
//   email: string;
//   position: number;
//   main_object: number;
// };

// export type ContactPersonPayloadData = PayloadWithCallback<ContactPersonPayload>;  -CONTACTS

// export type GetAllContactsPayload = { -CONTACTS
//   main_object?: number;
//   limit?: number;
//   offset?: number;
// };

// export type RemoveContactPersonPayload = { -CONTACTS
//   contactId: number;
//   pageId: number;
// };

// export type UpdateContactPersonPayload = { -CONTACTS
//   dataWithCallback: ContactPersonPayloadData;
//   contactId: number;
// };

// RESPONSE TYPES

export type MainObjectTypesResponseData = ResponseData<ObjectTypesList>;
export type MainObjectsResponseData = ResponseData<MainObjectList>;

// export type ContactPersonResponseData = { -CONTACTS
//   id: number;
//   last_name: string;
//   first_name: string;
//   middle_name: string;
//   work_phone: string;
//   mobile_phone: string;
//   email: string;
//   position: number;
//   main_object: number;
// };

// export type AllContactsPersonsResponseData = ResponseData<MainObjectContactsList>; -CONTACTS

export type FeedingResponse = {
  breakfast: {
    has_meal: boolean;
    price: string;
  };
  lunch: {
    has_meal: boolean;
    price: string;
  };
  dinner: {
    has_meal: boolean;
    price: string;
  };
  kids_meals_prices: KidsFeegingType[];
  is_required: boolean;
  has_kids_price: boolean;
  age_kids_free: number | undefined;
  main_object?: string;
};
export type FeedingSettingsType = {
  isRequired: boolean;
  has_breakfast: boolean;
  has_lunch: boolean;
  has_dinner: boolean;
  breakfast: string;
  lunch: string;
  dinner: string;
  has_kidsPrice: boolean;
  ageKidsFree: string;
  kids: KidsFeegingType[];
};

export type KidsFeegingType = {
  start_age: number;
  end_age: number | null;
  kids_breakfast: string;
  kids_lunch: string;
  kids_dinner: string;
};
export type Meal = {
  has_meal: boolean;
  price: string | null;
};

export type FeedingUpdateType = {
  breakfast?: Meal;
  lunch?: Meal;
  dinner?: Meal;
  kids_meals_prices?: KidsFeegingType[];
  is_required?: boolean;
  has_kids_price?: boolean;
  age_kids_free?: number | null;
  main_object?: string;
};

export type GpsCoordinates = {
  lat: string;
  lon: string;
};

export type MainObjectContacts = {
  phone: TelephoneType | null;
  email: string | null;
  coordinates: GpsCoordinates | null;
  social_networks: ResponseSocialNetworkType[];
  id: number;
  main_object: {
    id: string;
    name: string;
    object_type: {
      id: number;
      title: string;
      example: string;
    };
  };
};
export type ObjectContactsFormType = {
  phone: TelephoneType;
  email: string;
  lat: string;
  lon: string;
};

export type UpdateObjectContactsType = {
  phone?: TelephoneType;
  email?: string;
  coordinates?: GpsCoordinates | null;
};

export type SocialNetworkType = {
  id: number;
  title: string;
};

export enum SocialNetworks {
  INSTAGRAM = 'Instagram',
  FACEBOOK = 'Facebook',
  TELEGRAM = 'Telegram',
  VIBER = 'Viber',
  VK = 'ВКонтакте',
}

export type SocialNetworkFormType = {
  instagram: string;
  telegram: string;
  facebook: string;
  vk: string;
  viber: TelephoneType;
};
export type CreateSocialNetworkType = {
  account: string;
  social_network_type: number;
  main_object_contacts: number;
};
export type ResponseSocialNetworkType = {
  id: number;
  social_network_type: SocialNetworkType;
  account: string;
  main_object_contacts: number;
};
type ImageItem = {
  data_url: string;
  file: File;
};

export type BasicSettingsType = {
  objectName: string;
  objectType: string;
  country: string;
  region: string;
  locality: string;
  address: string;
  bookingImage: string | null;
  newBookingImage: ImageListType;
  homeImage: string | null;
  newHomeImage: ImageListType;
  rulesPdf: File | string | null;
  textRules: string;
};
